
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gp/tv",
      function () {
        return require("private-next-pages/gp/tv/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gp/tv"])
      });
    }
  